import type { Template } from "@/types";

export const LA_07_H1_V6: Template[] = [
{
    id: "la-07-h1v6-01",
    name: "LA 01 - H1V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 41, y: 55, width: 553, height: 368, rotation: 0, imageRotation: 0 },
            { id: "2", x: 738, y: 31, width: 140, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 886, y: 31, width: 140, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1034, y: 31, width: 140, height: 203, rotation: 0, imageRotation: 0 },
            { id: "5", x: 738, y: 242, width: 140, height: 203, rotation: 0, imageRotation: 0 },
            { id: "6", x: 886, y: 242, width: 140, height: 203, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1034, y: 242, width: 140, height: 203, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h1v6-02",
    name: "LA 02 - H1V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 123, y: 49, width: 391, height: 216, rotation: 0, imageRotation: 0 },
            { id: "2", x: 744, y: 49, width: 270, height: 376, rotation: 0, imageRotation: 0 },
            { id: "3", x: 123, y: 272, width: 125, height: 153, rotation: 0, imageRotation: 0 },
            { id: "4", x: 256, y: 272, width: 125, height: 153, rotation: 0, imageRotation: 0 },
            { id: "5", x: 389, y: 272, width: 125, height: 153, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1021, y: 49, width: 140, height: 185, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1021, y: 241, width: 140, height: 185, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h1v6-03",
    name: "LA 03 - H1V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 108, y: 49, width: 420, height: 240, rotation: 0, imageRotation: 0 },
            { id: "2", x: 108, y: 297, width: 100, height: 130, rotation: 0, imageRotation: 0 },
            { id: "3", x: 216, y: 297, width: 100, height: 130, rotation: 0, imageRotation: 0 },
            { id: "4", x: 323, y: 297, width: 99, height: 130, rotation: 0, imageRotation: 0 },
            { id: "5", x: 430, y: 297, width: 99, height: 130, rotation: 0, imageRotation: 0 },
            { id: "6", x: 719, y: 61, width: 234, height: 355, rotation: 0, imageRotation: 0 },
            { id: "7", x: 960, y: 61, width: 234, height: 355, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h1v6-04",
    name: "LA 04 - H1V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 159, y: 49, width: 312, height: 175, rotation: 0, imageRotation: 0 },
            { id: "2", x: 159, y: 231, width: 153, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 319, y: 231, width: 153, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 756, y: 49, width: 281, height: 376, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1044, y: 49, width: 96, height: 121, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1044, y: 177, width: 96, height: 120, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1044, y: 306, width: 96, height: 120, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h1v6-05",
    name: "LA 05 - H1V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 159, y: 49, width: 312, height: 175, rotation: 0, imageRotation: 0 },
            { id: "2", x: 159, y: 231, width: 153, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 319, y: 231, width: 153, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 795, y: 49, width: 157, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 795, y: 242, width: 157, height: 185, rotation: 0, imageRotation: 0 },
            { id: "6", x: 960, y: 49, width: 156, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 960, y: 242, width: 156, height: 185, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h1v6-06",
    name: "LA 06 - H1V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 70, y: 74, width: 498, height: 328, rotation: 0, imageRotation: 0 },
            { id: "2", x: 793, y: 35, width: 104, height: 131, rotation: 0, imageRotation: 0 },
            { id: "3", x: 793, y: 173, width: 104, height: 131, rotation: 0, imageRotation: 0 },
            { id: "4", x: 793, y: 311, width: 104, height: 130, rotation: 0, imageRotation: 0 },
            { id: "5", x: 905, y: 35, width: 213, height: 269, rotation: 0, imageRotation: 0 },
            { id: "6", x: 905, y: 311, width: 103, height: 130, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1015, y: 311, width: 103, height: 130, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h1v6-07",
    name: "LA 07 - H1V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 70, y: 74, width: 498, height: 328, rotation: 0, imageRotation: 0 },
            { id: "2", x: 793, y: 34, width: 104, height: 131, rotation: 0, imageRotation: 0 },
            { id: "3", x: 793, y: 172, width: 214, height: 268, rotation: 0, imageRotation: 0 },
            { id: "4", x: 905, y: 34, width: 103, height: 131, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1015, y: 34, width: 103, height: 131, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1015, y: 172, width: 103, height: 131, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1015, y: 310, width: 103, height: 130, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h1v6-08",
    name: "LA 08 - H1V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 106, y: 69, width: 417, height: 223, rotation: 0, imageRotation: 0 },
            { id: "2", x: 106, y: 299, width: 77, height: 108, rotation: 0, imageRotation: 0 },
            { id: "3", x: 191, y: 299, width: 77, height: 108, rotation: 0, imageRotation: 0 },
            { id: "4", x: 276, y: 299, width: 77, height: 108, rotation: 0, imageRotation: 0 },
            { id: "5", x: 361, y: 299, width: 77, height: 108, rotation: 0, imageRotation: 0 },
            { id: "6", x: 446, y: 299, width: 77, height: 108, rotation: 0, imageRotation: 0 },
            { id: "7", x: 773, y: 0, width: 367, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h1v6-09",
    name: "LA 09 - H1V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 48, width: 247, height: 383, rotation: 0, imageRotation: 0 },
            { id: "2", x: 254, y: 48, width: 246, height: 383, rotation: 0, imageRotation: 0 },
            { id: "3", x: 508, y: 48, width: 119, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 508, y: 243, width: 119, height: 187, rotation: 0, imageRotation: 0 },
            { id: "5", x: 634, y: 48, width: 514, height: 383, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1155, y: 48, width: 119, height: 187, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1155, y: 243, width: 119, height: 187, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-07-h1v6-10",
    name: "LA 10 - H1V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-07-h1_v6_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 48, width: 247, height: 383, rotation: 0, imageRotation: 0 },
            { id: "2", x: 254, y: 48, width: 246, height: 383, rotation: 0, imageRotation: 0 },
            { id: "3", x: 508, y: 48, width: 259, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 508, y: 243, width: 126, height: 187, rotation: 0, imageRotation: 0 },
            { id: "5", x: 642, y: 243, width: 125, height: 187, rotation: 0, imageRotation: 0 },
            { id: "6", x: 775, y: 48, width: 246, height: 383, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1028, y: 48, width: 246, height: 383, rotation: 0, imageRotation: 0 }
    ],
}
];